import { DateRangePicker } from 'react-dates';

const DateRangeFilter = ({
  formInput,
  focusedInput,
  setFocusedInput,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  isFullScreenRangeDatePickerOpen,
  isDayBlocked,
  isMobile,
}) => {
  return (
    <DateRangePicker
      startDateId="startDate"
      endDateId="endDate"
      disabled={!formInput?.destination}
      startDate={startDate}
      endDate={endDate}
      onDatesChange={({ startDate, endDate }) => {
        setStartDate(startDate);
        setEndDate(endDate);
      }}
      focusedInput={
        !isMobile || focusedInput
          ? focusedInput
          : !startDate || isFullScreenRangeDatePickerOpen
          ? 'startDate'
          : 'endDate'
      }
      onFocusChange={(input) => {
        setFocusedInput(input);
      }}
      onClose={() => {
        setFocusedInput(null);
      }}
      numberOfMonths={isMobile ? 1 : 2}
      startDatePlaceholderText={'Desde'}
      endDatePlaceholderText={'Hasta'}
      showClearDates
      daySize={40}
      isDayBlocked={isDayBlocked}
      key={startDate + endDate}
    />
  );
};

export default DateRangeFilter;
